import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DraftState {
  drafts: Record<string, string>;
  setDraft: (conversationId: string, message?: string) => void;
}

export default create<DraftState>()(
  persist(
    (set) => ({
      drafts: {},
      setDraft: (conversationId, message) => {
        set((state) => ({
          drafts: { ...state.drafts, [conversationId]: message || undefined },
        }));
      },
    }),
    { name: "draftInbox" },
  ),
);
